import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { addBudget, fetchExpenseCategories } from "../services/api";

export default function AddBudgetModal({ showForm, onToggle, onSuccess }) {
    const [amount, setAmount] = useState("");
    const [idExpenseCategory, setIdExpenseCategory] = useState("");
    const [categories, setCategories] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        fetchExpenseCategories().then(setCategories).catch(console.error);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage("");

        try {
            await addBudget({
                id_expense_category: Number(idExpenseCategory),
                budget_amt: Number(amount),
            });

            onSuccess();
            // Reset form
            setAmount("");
            setIdExpenseCategory("");
            setErrorMessage("");
        } catch (err) {
            setErrorMessage(err.message);
        }
    };

    const handleCancel = () => {
        setAmount("");
        setIdExpenseCategory("");
        setErrorMessage("");
        onToggle();
    };

    return (
        <AnimatePresence>
            {showForm && (
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                    className="bg-gray-800 rounded-xl shadow-2xl p-6 mb-6 overflow-hidden"
                >
                    <h3 className="text-xl font-semibold text-white mb-4 font-[Poppins]">
                        Add Monthly Budget
                    </h3>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-gray-300 mb-2 text-sm">Category</label>
                                <select
                                    value={idExpenseCategory}
                                    onChange={(e) => setIdExpenseCategory(e.target.value)}
                                    className="w-full px-3 py-2 bg-gray-700 text-white rounded-lg border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                    required
                                >
                                    <option value="">Select Category</option>
                                    {Array.isArray(categories) &&
                                        categories.map((c) => (
                                            <option
                                                key={c.id_expense_category}
                                                value={c.id_expense_category}
                                            >
                                                {c.expense_category_name}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-gray-300 mb-2 text-sm">Budget Amount</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    className="w-full px-3 py-2 bg-gray-700 text-white rounded-lg border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                    placeholder="0.00"
                                    required
                                />
                            </div>
                        </div>

                        {errorMessage && (
                            <p className="text-red-400 text-sm font-[Poppins]">{errorMessage}</p>
                        )}

                        <div className="flex gap-2 justify-end">
                            <button
                                type="button"
                                onClick={handleCancel}
                                className="px-4 py-2 bg-gray-600 hover:bg-gray-500 text-white rounded-lg transition"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="px-4 py-2 bg-gradient-to-r from-blue-500 to-sky-600 hover:opacity-90 text-white rounded-lg transition"
                            >
                                Add Budget
                            </button>
                        </div>
                    </form>
                </motion.div>
            )}
        </AnimatePresence>
    );
}